import React, { useMemo, useRef } from 'react';
import s from './s.module.less';
import { isMobile } from 'utils/common';

interface IProcessBarProps {
    currentStep: number;
}

const ProcessBar: React.FC<IProcessBarProps> = ({ currentStep = 1 }) => {
    const steps = useRef([
        { id: 1, title: 'Create profile' },
        { id: 2, title: 'Set up services' },
        { id: 3, title: 'List on Klarity Health' },
        { id: 4, title: 'Configure availability' },
    ]);

    const mobileRender = useMemo(() => {
        let { title } = steps.current[0];
        if (currentStep === 1) {
            title = steps.current[0].title;
        } else if (currentStep === 2) {
            title = steps.current[1].title;
        } else if (currentStep === 3) {
            title = steps.current[2].title;
        } else if (currentStep === 4) {
            title = steps.current[3].title;
        }

        return (
            <React.Fragment key={currentStep}>
                <div className={s.stepContainer}>
                    <div className={s.stepCircleContainer}>
                        <div
                            className={`${s.stepCircle} ${s.activeCircle}`}
                        >
                            <span
                                className={`${s.stepNumber} ${s.activeNumber}`}
                            >
                                {currentStep}
                            </span>
                        </div>
                    </div>
                    <span
                        className={`${s.stepTitle} ${s.activeTitle}`}
                    >
                        {title}
                    </span>
                </div>
            </React.Fragment>
        );
    }, [currentStep]);

    return (
        <div className={s.processBarContainer}>
            {
                isMobile() ?
                    mobileRender :
                    (
                        steps.current.map((step, index) => (
                            <React.Fragment key={step.id}>
                                <div className={s.stepContainer}>
                                    <div className={s.stepCircleContainer}>
                                        <div
                                            className={`${s.stepCircle} ${
                                                step.id === currentStep ? s.activeCircle : s.inactiveCircle
                                            }`}
                                        >
                                            <span
                                                className={`${s.stepNumber} ${
                                                    step.id === currentStep ? s.activeNumber : s.inactiveNumber
                                                }`}
                                            >
                                                {step.id}
                                            </span>
                                        </div>
                                    </div>
                                    <span
                                        className={`${s.stepTitle} ${
                                            step.id === currentStep ? s.activeTitle : s.inactiveTitle
                                        }`}
                                    >
                                        {step.title}
                                    </span>
                                </div>
                                {index < steps.current.length - 1 && (
                                    <div className={s.connectionLine} />
                                )}
                            </React.Fragment>
                        ),
                        )
                    )
            }
        </div>
    );
};

export default ProcessBar;
